import React from 'react';

const Toggle = ({ checked, onChange, disabled = false }) => {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={() => onChange?.(!checked)}
            className={`
                group relative w-[36px] h-[20px] p-[2px] border-0 rounded-[10px]
                flex-shrink-0 cursor-pointer transition-colors duration-150
                focus-visible:outline-none
                disabled:opacity-50 disabled:cursor-not-allowed
                ${checked
                    ? 'bg-[#1181F9] [@media(hover:hover)]:hover:bg-[#0564ca] active:bg-[#0564ca] disabled:bg-[#0075F8]'
                    : 'bg-[#E0E3E5] [@media(hover:hover)]:hover:bg-[#D3D6D9] active:bg-[#D3D6D9]'
                }
            `}
        >
            <i className={`
                block w-[16px] h-[16px] bg-white rounded-full
                transition-all duration-150
                ${checked
                    ? `translate-x-[16px]
                       shadow-[-1px_0_2px_rgba(0,0,0,0.06)]
                       group-focus-visible:shadow-[-1px_0_2px_rgba(0,0,0,0.06),0_0_0_6px_rgba(0,117,248,0.3)]
                       group-active:shadow-[-1px_0_2px_rgba(0,0,0,0.06),0_0_0_6px_rgba(0,117,248,0.3)]`
                    : `translate-x-0
                       shadow-[1px_0_2px_rgba(0,0,0,0.06)]
                       group-focus-visible:shadow-[1px_0_2px_rgba(0,0,0,0.06),0_0_0_6px_rgba(0,117,248,0.3)]
                       group-active:shadow-[1px_0_2px_rgba(0,0,0,0.06),0_0_0_6px_rgba(0,117,248,0.3)]`
                }
            `} />

            {disabled && (
                <span className="absolute inset-0 rounded-[10px] bg-black/10" />
            )}
        </button>
    );
};

export default Toggle;
